// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8936) return "static/chunks/8936-2b5923aa76f2c5aa.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"233":"810182408d9023f8","2417":"cb75eb524a93703f","6251":"efa6cef6c941cd2e","6693":"47e96f2955fabf9b","6735":"a3eb23c166e5ee5a"}[chunkId] + ".js";
};